angular.module('stack.common.ui.application.resolvers.ConstantResolver', [])

/**
 * The ConstantResolver service provides constant implementations
 * to controllers leveraging the resolve pattern on the router.
 *
 * @class ConstantResolver
 * @constructor
 * @module stack.common.ui.application.resolvers.ConstantResolver
 */
.factory('ConstantResolver', [
  '$q',
  function ($q) {
    'use strict';

    return function (constants) {
      var d = $q.defer();
      var obj = angular.extend({}, constants);

      d.resolve({ constants: obj });
      return d.promise;
    };
  }
]);
